module.exports = __webpack_public_path__ + "img/facebook1.3eb2d16e.png";